function _(o,f,t){f.exports=function(){return"function"==typeof"foo".repeat&&"foofoo"==="foo".repeat(2)}}
//# sourceMappingURL=is-implemented.min.js.map